import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyDUlUhx30YxBEFjaOsdljP0Ai0OdrZvmVA",
  authDomain: "saascadetech-com.firebaseapp.com",
  databaseURL: "https://saascadetech-com.firebaseio.com",
  projectId: "saascadetech-com",
  storageBucket: "saascadetech-com.appspot.com",
  messagingSenderId: "682768492126",
  appId: "1:682768492126:web:c87ecde8d30b780d"
};
firebase.initializeApp(config);
export const db = firebase.firestore();
export const functions = firebase.functions();
export const auth = firebase.auth();
export const storage = firebase.storage();
export default firebase;
